import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

type BulkDeleteServiceRequestsParams = {
  serviceRequestIds: string[];
};

type BulkDeleteServiceRequestsResponse = {
  deletedCount: number;
};

type BulkDeleteServiceRequestsResult = {
  success: boolean;
  data?: BulkDeleteServiceRequestsResponse;
  error?: string;
  statusCode?: number;
};

export async function bulkDeleteServiceRequests({
  serviceRequestIds,
}: BulkDeleteServiceRequestsParams): Promise<BulkDeleteServiceRequestsResult> {
  try {
    const response = await fetcher(`${API_BASE_PATH}/bulk`, {
      method: 'DELETE',
      body: { serviceRequestIds },
    });

    if (!response.ok) {
      const responseData = await response.json();
      return {
        success: false,
        error: responseData?.message || 'Failed to delete service requests',
        statusCode: response.status,
      };
    }

    const responseData: BulkDeleteServiceRequestsResponse =
      await response.json();
    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to delete service requests';
    return {
      success: false,
      error: errorMessage,
      statusCode: 500,
    };
  }
}
